<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hjsgcZ/tc-custom/9781426873966.jpg?1705201833618" alt="This image is the cover for the book One True Thing, Heartbreak Canyon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One True Thing, Heartbreak Canyon
      </h1>
      <p class="bookDescription body article font2">
        <p>Ex-detective Jace Barnett's finely tuned instinctswent into overdrive when he met his beautifulnew neighbor with the fictitious past. His attemptsto uncover her true identity met a dead end everytime. She was a tantalizing mystery—one thatspelled trouble for them both.It broke Cassidy McRae's heart to lie to the manwho made her heart skip a beat from passioninstead of fear. Something about Jace told her thathe would protect her with his life—if she couldonly trust him enough to be honest. But thoughthe truth could set her free, it might also getthem both killed….</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marilyn Pappano
      </h2>
      
      <p class="authorDescription body article">Author of 80+ books, Marilyn Pappano has been married for thirty+ years to the best husband a writer could have. She's written more than 80 books and has won the RITA and many other awards. She blogs at www.the-twisted-sisters.com and can be found at&#160;<a href="http://www.marilyn-pappano.com">www.marilyn-pappano.com</a>. She and her husband live in Oklahoma with five&#160;rough-and-tumble dogs.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c14b82e